$(".nav-link__show").click(function () {
    if($(this).parents(".nav-link").hasClass("_active")){
        $(".nav-link").removeClass("_active")
    }else{
        $(".nav-link").removeClass("_active")
        $(this).parents(".nav-link").addClass("_active")
    }
})


$(document).mouseup(function(e) {
    var div = $('.nav-link');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});
